/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

const HiddenField = props => {
  const { name, validate } = props;

  const Input = ({ input }) => {
    return <input {...input} type="hidden" />;
  };
  return <Field name={name} render={Input} validate={validate} />;
};

HiddenField.propTypes = {
  name: PropTypes.string.isRequired
};

export default HiddenField;
